// extracted by mini-css-extract-plugin
export default {"container1":"RolesLayout_container1__zQZHd","container2":"RolesLayout_container2__IiDN9"};